import styled from 'styled-components'
import Header from '../../components/header/Header'
import ResultsInterpretation from '../../components/resultsInterpretation/ResultsInterpretation'
import RecomendAndNextSteps from '../../components/RecomendAndNextSteps/RecomendAndNextSteps'
import Footer from '../../components/footer/Footer'
import PersonalizedHealthEvaluation from '../../components/personalizedHealthEvaluation/PersonalizedHealthEvaluation'
import Inflamation from '../../components/inflamation/Inflamation'
import AboutBiomarker from '../../components/modals/AboutBiomarker'
import { Dialog, Modal } from '@mui/material'
import { useContext, useEffect } from 'react'
import GlobalContext from '../../components/GlobalContext'
import { getDefatultIndicatorValues } from '../../utils/biomarkers'
import { useNavigate } from 'react-router-dom'
import { getUrl } from '../../components/getSubjectId'

export const Container = styled.div`
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 10;
  
   > div {
    width: 1100px;
    max-width: 90%;
    background: red;
  }
   > [data-grey] {
    width: 100%;
    max-width: 100%;
    background: grey;
  }
   > [data-grey] > div {
    width: 1100px;
    max-width: 90%;
    background: green;
    margin: 0 auto;
  }

  @media (max-width: 1100px) {
    max-width: 90%;
  }
`

export const Title = styled.p`
    font-family: Libre Baskerville;
    margin-top: 0px;
    margin-bottom: 24px;
    letter-spacing: 0.02em;
    text-align: left;
    color: var(--text-main, #1A1A1A);

font-family: Libre Baskerville;
font-size: 40px;
font-style: normal;
font-weight: 700;
line-height: 52px; /* 130% */
letter-spacing: 0.8px;
    > div {
        font-family: Libre Baskerville;
        font-size: 40px;
        font-weight: 700;
        letter-spacing: 0.02em;
        text-align: left;
    }
`

export const Title2 = styled.p`
    font-family: Libre Baskerville;
    margin-top: 0px;
    margin-bottom: 24px;
    letter-spacing: 0.02em;
    text-align: left;
    color: var(--text-main, #1A1A1A);

color: var(--Text-Main, #1A1A1A);

/* Display/M Semibold */
font-family: Libre Baskerville;
font-size: 32px;
font-style: normal;
font-weight: 700;
line-height: 44px; /* 137.5% */
letter-spacing: 0.64px;
     div, p {
color: var(--Text-Main, #1A1A1A);

/* Display/M Semibold */
font-family: Libre Baskerville;
font-size: 32px;
font-style: normal;
font-weight: 700;
line-height: 44px; /* 137.5% */
letter-spacing: 0.64px;
    }
`
export const Title3 = styled.p`
    font-family: Libre Baskerville;
    margin-top: 0px;
    margin-bottom: 24px;
    letter-spacing: 0.02em;
    text-align: left;
    color: var(--text-main, #1A1A1A);

font-family: Libre Baskerville;
font-size: 38px!important;
font-style: normal;
font-weight: 700;
line-height: 52px; /* 130% */
letter-spacing: 0.8px;
     div, p {
        font-family: Libre Baskerville;
        font-size: 38px!important;
        font-weight: 700;
        letter-spacing: 0.02em;
        text-align: left;
    }
`

const Background = styled.div`
  height: 100%;
  width: 100%;
`

export const ReadMore = styled.b`
  cursor: pointer;

  color: var(--primary-40, #3baab0);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0.32px;
`

export const Heading = styled.span`
color: var(--Text-Main, #1A1A1A);

/* Header/S Semibold */
font-family: Roboto;
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px; /* 150% */
letter-spacing: 0.32px;
`
export const List = styled.ul`
  margin-top: 10px;

  li::marker {
    color: #bfbfbf;
    font-size: 16px;
  }
`
export const Li = styled.li``

export const BiomarkersContainer = styled.div`
  width: 100%;

  margin-top: 20px;

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-column-gap: 12px;
  grid-row-gap: 12px;
`

export const ScrollWrapper = styled.div`
  width: 100%;
  overflow-y: hidden;
  position: relative;

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 100px;
  }

  ::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px rgb(0 0 0 / 46%);
    border-radius: 100px;
  }
`

export const ModalMUI = styled(Modal)`
  display: flex;
  justify-content: center;
  overflow-y: auto;
  margin-top: 100px;
  height: fit-content;
  z-index: 5;
  > div {
    z-index: 10;
  }
`
export const DialogMUI = styled(Dialog)`
  .MuiPaper-root {
    width: 100%;
    padding: 10px;
    vertical-align: top;
    margin-top: 120px;
  }
`


const Indicator = () => {
  let navigate = useNavigate();
  useEffect(() => {
    let {theme} = getDefatultIndicatorValues() || {};
    console.log("summarryryryryryryryryryry", getDefatultIndicatorValues())
    if (theme) {
      navigate(getUrl('/theme/' + theme))
    }
  }, [])

  return (
    <div data-animch data-level2>
      <PersonalizedHealthEvaluation />
      <ResultsInterpretation />
      <RecomendAndNextSteps />
    </div>
  )
}

export default Indicator
